import { Button, Grid, Tooltip, Typography } from '@material-ui/core';
import React from 'react';
import { getCalendarTitle } from '../../../calendarHelpers';
import { ChevronLeftIcon, ChevronRightIcon } from '../../../icons';
import { TimeslotSyncInfo } from '../../../TimeslotSyncInfo';

const CalendarNavigation = ({ startDate, endDate, setCalendarDate, customButtons }) => {
    return (
        <Grid
            container
            item
            xs={12}
            spacing={0}
            justifyContent="space-between"
            className="mt-2 mb-2"
            alignItems="center"
        >
            <Grid item>
                <Typography variant="h2">{getCalendarTitle(startDate, endDate)}</Typography>
            </Grid>
            <Grid item>
                {Object.entries(customButtons).length !== 0 ? (
                    <>
                        {Object.entries(customButtons).map(([buttonKey, buttonProps]) => {
                            switch (buttonKey) {
                                case 'sync': {
                                    const { isEnabled, ...restButtonProps } = buttonProps;
                                    if (!isEnabled) {
                                        return null;
                                    }
                                    return <TimeslotSyncInfo key="sync" {...restButtonProps} />;
                                }
                                case 'prev':
                                    return (
                                        <Tooltip title="Previous week" key="prev">
                                            <Button
                                                variant="contained"
                                                color="primary"
                                                onClick={() => {
                                                    setCalendarDate(true);
                                                    customButtons.prev.click();
                                                }}
                                                className="calendar-navigation-left"
                                            >
                                                <ChevronLeftIcon />
                                            </Button>
                                        </Tooltip>
                                    );
                                case 'next':
                                    return (
                                        <Tooltip title="Next week" key="next">
                                            <Button
                                                variant="contained"
                                                color="primary"
                                                onClick={() => {
                                                    setCalendarDate();
                                                    customButtons.next.click();
                                                }}
                                                className="calendar-navigation-right"
                                            >
                                                <ChevronRightIcon />
                                            </Button>
                                        </Tooltip>
                                    );
                                case 'findNextButton':
                                    return (
                                        <Tooltip
                                            title="Find next available timeslot"
                                            key="findNext"
                                        >
                                            <Button
                                                variant="contained"
                                                color="primary"
                                                onClick={() => customButtons.findNextButton.click()}
                                            >
                                                {customButtons.findNextButton.text}
                                            </Button>
                                        </Tooltip>
                                    );
                                default:
                                    return null;
                            }
                        })}
                    </>
                ) : (
                    <>
                        <Tooltip title="Previous week">
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={() => setCalendarDate(true)}
                                className="calendar-navigation-left"
                            >
                                <ChevronLeftIcon />
                            </Button>
                        </Tooltip>
                        <Tooltip title="Next week">
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={() => setCalendarDate()}
                                className="calendar-navigation-right"
                            >
                                <ChevronRightIcon />
                            </Button>
                        </Tooltip>
                    </>
                )}
            </Grid>
        </Grid>
    );
};

export default CalendarNavigation;
